<form class="flexer padding no-top-padding">
  <div class="form-title">
    <div class="form-title-text">Materiaal & afmetingen</div>
  </div>

  <div class="d-flex ">
    <div>
      <div class="form-sub-title">Type folie</div>
      <mat-form-field appearance="outline">
        <mat-select
          name="materialType"
          matInput
          placeholder="Maak een keuze"
          [(ngModel)]="inputProduct.temporaryMaterial"
          [disabled]="disabled"
          (ngModelChange)="materialTypeUpdate($event)"
          required
        >
          <mat-option
            *ngFor="let option of temporaryMaterialOptions"
            [value]="option.value"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <windowsticker-material-picker
      class="form-field flexer"
      [inputMaterialAware]="inputProduct"
      [sizesEndpoint]="'/window_sticker_sizes/unpaged'"
      [updateEmitter]="outPutWindowSticker"
      [temporaryMaterialChanged]="temporaryMaterialChanged"
      [client]="client"
      [disabled]="disabled"
    ></windowsticker-material-picker>
  </div>

  <div class="form-sub-title">Stickers</div>
  <!--  deel per lijn van stickerparts-->
  <mat-card
    class="mat-elevation-z0 under-space"
    *ngFor="let stickerPart of inputProduct.stickerParts; let index = index"
  >
    <div class="d-flex justify-content-between">
      <div class="form-sub-title">Sticker #{{ index + 1 }}</div>
      <div *ngIf="!disabled" (click)="delete(index)" class="close">
        <mat-icon svgIcon="close"></mat-icon>
      </div>
    </div>

    <form class="form d-flex justify-content-between">
      <div>
        <div class="subtitle font-weight-bold">Raam</div>
        <div class="d-flex yop-space">
          <div class="first-form-field">
            <div class="size-label">Hoogte (in cm)</div>
            <mat-form-field appearance="outline">
              <input
                type="number"
                placeholder="Hoogte in cm"
                matInput
                [(ngModel)]="stickerPart.windowHeight"
                [disabled]="disabled"
                name="windowHeight"
                (ngModelChange)="windowHeightChange($event, index)"
                required
              />
            </mat-form-field>
          </div>

          <div class="form-field">
            <div class="size-label">Breedte (in cm)</div>
            <mat-form-field appearance="outline">
              <input
                type="number"
                placeholder="Breedte in cm"
                matInput
                [(ngModel)]="stickerPart.windowWidth"
                [disabled]="disabled"
                name="windowWidth"
                (ngModelChange)="windowWidthChange($event, index)"
                required
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="flex-column bottom">
        <button
          class="button"
          (click)="EqualSizes(index)"
          type="button"
          mat-button
          [disabled]="equalDisabled || disabled"
        >
          =
        </button>
      </div>
      <div>
        <div class="subtitle font-weight-bold">Sticker</div>
        <div class="d-flex yop-space">
          <div class="first-form-field">
            <div class="size-label">Hoogte (in cm)</div>
            <mat-form-field appearance="outline">
              <input
                type="number"
                placeholder="Hoogte in cm"
                matInput
                [(ngModel)]="stickerPart.stickerHeight"
                [disabled]="disabled"
                name="stickerHeight"
                (ngModelChange)="stickerHeightChange($event, index)"
                required
              />
            </mat-form-field>
          </div>

          <div class="form-field">
            <div class="size-label">Breedte (in cm)</div>
            <mat-form-field appearance="outline">
              <input
                type="number"
                placeholder="Breedte in cm"
                matInput
                [(ngModel)]="stickerPart.stickerWidth"
                [disabled]="disabled"
                name="stickerWidth"
                (ngModelChange)="stickerWidthChange($event, index)"
                required
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div class="no-margin no-padding">
      <textarea-input
        [placeholder]="'Extra info'"
        [initContent]="stickerPart.description"
        [client]="client"
        [disabled]="disabled"
        (answer)="descriptionChanged($event, index)"
      >
      </textarea-input>
    </div>
  </mat-card>
  <!--  deel per lijn van stickerparts-->

  <div>
    <button class="button" (click)="addStickerPart()" type="button" mat-button>
      Extra sticker toevoegen
    </button>
  </div>

  <div *ngIf="inputProduct.stickerParts.length > 1 && !fromOldSystem">
    <div class="form-sub-title under-space">Raamstijl</div>
    <yes-no
      [subtitle]="'Raamstijl aanwezig'"
      [yesValue]="'Ja'"
      [noValue]="'Nee'"
      [value]="inputProduct.windowFrame"
      [neverShowExtraInstructions]="true"
      [disabled]="disabled"
      [nullIsFalse]="false"
      [nullable]="true"
      (answer)="setWindowFrame($event)"
    ></yes-no>

    <div class="form-field" *ngIf="inputProduct.windowFrame">
      <div class="size-label">Breedte raamstijl (in cm)</div>
      <mat-form-field appearance="outline">
        <input
          type="number"
          placeholder="Breedte in cm"
          matInput
          [(ngModel)]="inputProduct.windowFrameWidth"
          [disabled]="disabled"
          name="windowWidth"
          (ngModelChange)="Change()"
          required
        />
      </mat-form-field>
    </div>

    <yes-no
      *ngIf="inputProduct.windowFrame"
      [subtitle]="'Wil je dat we over de raamstijl plakken?'"
      [yesValue]="'Ja'"
      [noValue]="'Nee'"
      [value]="inputProduct.stickOverWindowFrame"
      [showExtraInstructionsOn]="null"
      [disabled]="disabled"
      (answer)="setStickOver($event)"
    ></yes-no>
  </div>
  <design-picker
    *ngIf="!client && !fromOldSystem"
    [inputProduct]="inputProduct"
    [inputProject]="inputProject"
    [disabled]="disabled"
    (updateProduct)="outPutWindowSticker.emit()"
  >
  </design-picker>
</form>
<internal-project-form
  *ngIf="!client && !fromOldSystem"
  [inputProject]="inputProject"
  [inputProduct]="inputProduct"
  [involvedCompanies]="involvedCompanies"
  [pmsColorAdded]="pmsColorAdded"
  (updateProduct)="outPutWindowSticker.emit()"
></internal-project-form>
